import { fExecuteAPI } from "../../Server/Apis";
import {
  WMSInbound_grnAttributes_GETROW,
  WMSIInbound_WMINV03RSPMSPDetail_API,
  WmsInbound_getPendingPo_API,
  WmsInbound_getPallet_API,
  WMSInbound_validateReceivingPost_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fCalculate_Detail,
  GetCostUpdate,
  Get_TransItemStockUOM,
  userBasedHideField,
} from "../../Utility/Utilitys";

import {
  Set_InboundGRN_HeadObject_DrCrAccount,
  Set_WmsInboundGRN_HeadObject_Set,
  Set_InboundGRN_HeadObject_A_VocNo,
  Set_InboundGRN_HeadObject_A_PayMode,
  Set_InboundGRN_HeadObject_DiscFlag,
  Set_InboundGRN_HeadObject_A_Buyer,
  Wms_HeadObject_SalesGroup_SalesMan_Set,
} from "./SliceWmsInboundGRN";

import {
  vRdxUserInfo,
  KernCAConfig,
  vRdxtax,
  InboundGrn,
} from "../../Redux/roStore";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { fcheck_null_undefine_replace_empty } from "./../../Utility/Utilitys";
 
// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = InboundGrn();

export const BatchDetail_ErrorMsg_Init = {
  BatchDetail_SrNo: "",
  BatchDetail_BatchNo: "",
  BatchDetail_MFDate: "",
  BatchDetail_ExpDate: "",
  BatchDetail_Qty: "",
  BatchDetail_Unit: "",
  BatchDetail_PackQty: "",
  BatchDetail_BaseQty: "",
};
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefDocVer: "",
  A_RefDocNo: "",
  A_RefDocTyp: "",
  A_RefDocTypName: "",
  A_RefNo: "",
  A_RefDt: "",
  InboundType: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  VendorInvAmount: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",
  TaxType: "",
  offer: "",
  A_Buyer: "",
  A_Buyername: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Type: "",
  A_Rounding: "",
  A_DiscFlag: "",
  A_LC: "",
  A_Charges1: "",
  A_DocStat: "",
  A_PutAway: "",
  A_AutoBatch: "",
  xErrorMsg: "",
  virtualBin: "",
  TeleUser:""
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  PalletType:"",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_CI: "",
  B_Unit: "",
  B_PackQty: "",
  SplDisc: "",
  B_URateFc: "",
  B_URateLc: "",
  B_GrossAmt: "",
  B_TDiscPerc: "",
  B_TDiscAmt: "",
  B_LDiscPerc: "",
  B_LDiscAmt: "",
  B_FocFlag: "",
  B_AprmtFlag: "",
  B_FocAmt: "",
  B_ExciseTaxAmt: "",
  B_ExciseTaxNetAmt: "",
  SplDiscAmt: "",
  B_Base_Rate: "",
  B_TaxDept: "",
  B_TaxPerc: "",
  B_TaxAmt: "",
  B_TaxDept2: "",
  B_TaxPerc2: "",
  B_TaxAmt2: "",
  B_NetAddCess: "",
  RebateType: "",
  ReduceCost: "",
  SplDiscPerc: "",
  B_NetAmt: "",
  B_IncGroup: "",
  B_SuprvPerc: "",
  B_OthersPerc: "",
  B_SLANSuprv: "",
  B_SlabAmtSuprv: "",
  B_SLANOther: "",
  B_SlabAmtOther: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "WMINV03";

const sFocFlagArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
];
export const sLoadedCostAccountArr = ["Vendor", "G.L A/c"];
export const sLoadedCostToggleData = ["Any", "Code", "Name"];

export const Loaded_Cost_Freight_Init = {
  Loaded_Cost_Freight_Acc: "",
  Loaded_Cost_Freight_Code: "",
  Loaded_Cost_Freight_Name: "",
  Loaded_Cost_Customs_Acc: "",
  Loaded_Cost_Customs_Code: "",
  Loaded_Cost_Customs_Name: "",
  Loaded_Cost_Discount_Code: "",
  Loaded_Cost_Discount_Name: "",
  Loaded_Cost_SplDiscount_Code: "",
  Loaded_Cost_SplDiscount_Name: "",
};
export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];
const sFrom = [
  { Uid: "VENDOR_INV", Name: "Vendor" },
  { Uid: "TRANSFER_RETURN", Name: "Outlet" },
  { Uid: "SALES_RETURN", Name: "Sales Return" },
];

const sPaymode = [
  { Uid: "CASH", Name: "Cash" },
  { Uid: "CREDIT", Name: "Credit" },
];

const sTax = [
  { Uid: "INTRN001", Name: "VAT" },
  { Uid: "INTRN002", Name: "Inter.Comp" },
  { Uid: "INTRN003", Name: "Import" },
];

const TypeArr = [
  { Uid: "", Name: "" },
  { Uid: "Linewise Rebate", Name: "Linewise Rebate" },
  { Uid: "Credit Note", Name: "Credit Note" },
];
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];
//GCcustomer end
const fKeyInboundGrn = (event) => {
  // WmsInboundGrnContent
  const form = document.getElementById("WmsInboundGrnHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};
export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig(); 
  const iShowField = DBKernObj.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};

const fKeyInboundGrnContent = (event) => {
  // WmsInboundGrnContent
  const form = document.getElementById("WmsInboundGrnContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

export const GetPengingPo = async (
  xVocNo,
  xVocTyp,
  setGridDataAccountDetailRows
) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const iAccountPostingDetail = await WmsInbound_getPendingPo_API(vObj);
  if (iAccountPostingDetail?.status === 200) {
    setGridDataAccountDetailRows(iAccountPostingDetail?.data?.ResultSet);
    console.log(iAccountPostingDetail?.data?.ResultSet);
    return iAccountPostingDetail?.data?.ResultSet;
  }
};
export const GetPallet = async (xVocNo, xVocTyp, setPalletData) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const resp = await WmsInbound_getPallet_API(vObj);
  if (resp?.status === 200) {
    setPalletData(resp?.data?.ResultSet);
    console.log(resp?.data?.ResultSet);
    return resp?.data?.ResultSet;
  } else {
    setPalletData([]);
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  sFooterObj,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PutAway === "N" &&
    (vRdxHead.virtualBin === "" ||
      vRdxHead.virtualBin === null ||
      vRdxHead.virtualBin === undefined)
  ) {
    fAlertToast("INFO", "virtualBin should not be empty");
    iRes = false;
  } else if (vRdxHead.A_PutAway === "Y" && vRdxHead.virtualBin !== "") {
    fAlertToast("INFO", "virtualBin should be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }

  if (sFooterObj.A_LandVal < 0) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Rounding: "Transaction amount should be greater than zero",
    }));
    fAlertToast("INFO", "Transaction amount should be greater than zero");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDocVer === "" &&
    vRdxHead.InboundType === "TRANSFER_RETURN"
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDocVer: "RefDocVer should not be empty",
    }));
    fAlertToast("INFO", "RefDocVer should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDocNo === "" &&
    vRdxHead.InboundType === "TRANSFER_RETURN"
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDocNo: "A_RefDocNo should not be empty",
    }));
    fAlertToast("INFO", "A_RefDocNo should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDocTyp === "" &&
    vRdxHead.InboundType === "TRANSFER_RETURN"
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDocTyp: "RefDocTyp should not be empty",
    }));
    fAlertToast("INFO", "RefDocTyp should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDocTypName === "" &&
    vRdxHead.InboundType === "TRANSFER_RETURN"
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDocTypName: "RefDocTypName should not be empty",
    }));
    fAlertToast("INFO", "RefDocTypName should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_RefNo === "" ||
    vRdxHead.A_RefNo === null ||
    vRdxHead.A_RefNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be empty" }));
    fAlertToast("INFO", "Text should not be empty");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "POS") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be POS" }));
    fAlertToast("INFO", "Text should not be POS");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "CREDIT") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text should not be CREDIT" }));
    fAlertToast("INFO", "Text should not be CREDIT");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be empty",
    }));
    fAlertToast("INFO", "Reference Date should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.UnloadingBay === "" ||
    vRdxHead.UnloadingBay === null ||
    vRdxHead.UnloadingBay === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      UnloadingBay: "Unloading should not be empty",
    }));
    fAlertToast("INFO", "Unloading should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.InboundType === "" ||
    vRdxHead.InboundType === null ||
    vRdxHead.InboundType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      InboundType: "GRN Type should not be empty",
    }));
    fAlertToast("INFO", "GRN Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be empty" }));
    fAlertToast("INFO", "Location should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Buyer === "" ||
    vRdxHead.A_Buyer === null ||
    vRdxHead.A_Buyer === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Buyer: "Buyer should not be empty" }));
    fAlertToast("INFO", "Buyer should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.VendorInvAmount === "" ||
    vRdxHead.VendorInvAmount === null ||
    vRdxHead.VendorInvAmount === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      VendorInvAmount: "Vendor Inv.Amt should not be empty",
    }));
    fAlertToast("INFO", "Vendor Inv.Amt should not be empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_PayMode === "" ||
    vRdxHead.A_PayMode === null ||
    vRdxHead.A_PayMode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PayMode: "PayMode should not be Empty",
    }));
    fAlertToast("INFO", "PayMode should not be Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_Curr === "" ||
    vRdxHead.A_Curr === null ||
    vRdxHead.A_Curr === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
    fAlertToast("INFO", "Curr should not be empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_ExRate === "" ||
    Number(vRdxHead.A_ExRate) === 0 ||
    vRdxHead.A_ExRate === null ||
    vRdxHead.A_ExRate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ExRate: "ExRate should not be empty",
    }));
    fAlertToast("INFO", "ExRate should not be empty");
    iRes = false;
  }
  
  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("INFO", "Tax Type should not be Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.offer === "" ||
    vRdxHead.offer === null ||
    vRdxHead.offer === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      offer: "Offer should not be Empty",
    }));
    fAlertToast("INFO", "Offer should not be Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_CrAc === "" ||
    vRdxHead.A_CrAcName === "" ||
    vRdxHead.A_CrAc === null ||
    vRdxHead.A_CrAc === undefined ||
    vRdxHead.A_CrAcName === null ||
    vRdxHead.A_CrAcName === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_CrAc: "CrAc is Empty" }));
    fAlertToast("INFO", "CrAc is Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_DrAc === "" ||
    vRdxHead.A_DrAcName === "" ||
    vRdxHead.A_DrAc === null ||
    vRdxHead.A_DrAc === undefined ||
    vRdxHead.A_DrAcName === null ||
    vRdxHead.A_DrAcName === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_DrAc: "DrAc is Empty" }));
    fAlertToast("INFO", "DrAc is Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_Type === "" ||
    vRdxHead.A_Type === null ||
    vRdxHead.A_Type === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Type: "Type should not be Empty" }));
    fAlertToast("INFO", "Type should not be Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.InboundType === "SALES_RETURN" &&
    userBasedHideField() &&
    (vRdxHead.TeleUser === "" ||
      vRdxHead.TeleUser === null ||
      vRdxHead.TeleUser === undefined)
  ) {
    setErrorMsg((obj) => ({ ...obj, TeleUser: "TeleUser should not be Empty" }));
    fAlertToast("INFO", "TeleUser should not be Empty");
    iRes = false;
  }
  
  if (
    vRdxHead.A_DiscFlag === "" ||
    vRdxHead.A_DiscFlag === null ||
    vRdxHead.A_DiscFlag === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_DiscFlag: "DiscFlag should not be Empty",
    }));
    fAlertToast("INFO", "DiscFlag should not be Empty");
    iRes = false;
  }
 

  return iRes;
};


const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData,
  sIncentiveGroups
) => {
  const { DBKernObj } = KernCAConfig();
 

  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.PalletType === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      PalletType: "PalletType should not be empty",
    }));
    fAlertToast("INFO", "PalletType should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (
    (sBufferObj.B_CI === "" ||
      sBufferObj.B_CI === null ||
      sBufferObj.B_CI === undefined) &&
    MultiCardFlag()
  ) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_CI: "Card Id should not be empty",
    }));
    fAlertToast("INFO", "Card Id should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "" || Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Item quantity should not be zero",
    }));
    fAlertToast("INFO", "Item quantity should not be zero");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }

  if (UnitRateFlag()) {
    if (Number(sBufferObj.B_URateFc) <= 0 || sBufferObj.B_URateFc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Unit rate[F.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[F.C] should not be Zero");
      iRes = false;
    }

    if (Number(sBufferObj.B_URateLc) <= 0 || sBufferObj.B_URateLc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateLc: "Unit rate[L.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[L.C] should not be Zero");
      iRes = false;
    }

    if (sBufferObj.B_GrossAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "GrossAmt should not be Empty",
      }));
      fAlertToast("INFO", "GrossAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TDiscPerc === "" || sBufferObj.B_TDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("INFO", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_LDiscPerc === "" || sBufferObj.B_LDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line discount.% should not be empty",
      }));
      fAlertToast("INFO", "Line discount.% should not be empty");
      iRes = false;
    }

    if (
      (Number(sBufferObj.B_LDiscPerc) <= 0 &&
        Number(sBufferObj.B_LDiscAmt) !== 0) ||
      (Number(sBufferObj.B_LDiscPerc) !== 0 &&
        Number(sBufferObj.B_LDiscAmt) === 0)
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line Disc.% or amount should be Zero",
      }));
      fAlertToast("INFO", "Line Disc.% or amount should be Zero");
      iRes = false;
    }else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      fAlertToast("INFO", "DiscPerc Percentage must be greater than 0 and less than or equal to 100");
     
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc:
          "DiscPerc Percentage must be greater than 0 and less than or equal to 100",
      }));
      iRes = false;
    }

    if (sBufferObj.B_FocFlag === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be Empty",
      }));
      fAlertToast("INFO", "FocFlag should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_FocAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("INFO", "FocAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxNetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }
    if (sBufferObj.SplDisc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDisc: "SplDiscAmt should not be Empty",
      }));
      fAlertToast("INFO", "SplDiscAmt should not be Empty");
      iRes = false;
    }


    if (sBufferObj.B_TaxDept === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxDept: "TaxDept should not be Empty",
      }));
      fAlertToast("INFO", "TaxDept should not be Empty");
      iRes = false;
    }
    if (sBufferObj.B_TaxPerc === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("INFO", "TaxPerc is Empty");
      iRes = false;
    }


    if (sBufferObj.B_TaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TaxAmt: "TaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "TaxAmt should not be Empty");
      iRes = false;
    }
    if (sBufferObj.B_TaxDept2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("INFO", "TaxDept2 is Empty");
      iRes = false;
    }
    
    if (sBufferObj.B_TaxPerc2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("INFO", "TaxPerc2 is Empty");
      iRes = false;
    }
    
    if (sBufferObj.B_TaxAmt2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("INFO", "TaxAmt2 is Empty");
      iRes = false;
    }
    
    if (sBufferObj.B_NetAddCess === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "B_NetAddCess is Empty",
      }));
      fAlertToast("INFO", "B_NetAddCess is Empty");
      iRes = false;
    }
    
    if (sBufferObj.ReduceCost === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        ReduceCost: "Reduce Cost is Empty",
      }));
      fAlertToast("INFO", "Reduce Cost is Empty");
      iRes = false;
    }
    
    if (sBufferObj.SplDiscPerc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDiscPerc: "SplDiscPerc is Empty",
      }));
      fAlertToast("INFO", "SplDiscPerc is Empty");
      iRes = false;
    }
    
    if (sBufferObj.B_NetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAmt: "NetAmt should not be Empty",
      }));
      fAlertToast("INFO", "NetAmt should not be Empty");
      iRes = false;
    }

    if (vRdxHead.InboundType === "SALES_RETURN" && DBKernObj.SONAS_INVOICE?.Val === "Y") {
      if (sBufferObj.B_IncGroup === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_IncGroup: "Incentive group should not be empty",
        }));
        fAlertToast("INFO", "Incentive group should not be empty");
        iRes = false;
      }
      if (sBufferObj.B_SuprvPerc === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SuprvPerc: "SuprvPerc is Empty",
        }));
        fAlertToast("INFO", "SuprvPerc is Empty");
        iRes = false;
      }
      
      if (sBufferObj.B_OthersPerc === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_OthersPerc: "OthersPerc is Empty",
        }));
        fAlertToast("INFO", "OthersPerc is Empty");
        iRes = false;
      }
      
      if (sBufferObj.B_SLANSuprv === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANSuprv: "SLANSuprv is Empty",
        }));
        fAlertToast("INFO", "SLANSuprv is Empty");
        iRes = false;
      }
      
      if (sBufferObj.B_SlabAmtSuprv === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtSuprv: "SlabAmtSuprv is Empty",
        }));
        fAlertToast("INFO", "SlabAmtSuprv is Empty");
        iRes = false;
      }
      
      if (sBufferObj.B_SLANOther === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SLANOther: "SLANOther is Empty",
        }));
        fAlertToast("INFO", "SLANOther is Empty");
        iRes = false;
      }
      
      if (sBufferObj.B_SlabAmtOther === "") {
        setErrorMsgDetail((obj) => ({
          ...obj,
          B_SlabAmtOther: "SlabAmtOther is Empty",
        }));
        fAlertToast("INFO", "SlabAmtOther is Empty");
        iRes = false;
      }
      
    }
  }

  return iRes;
};

const fValidationBatch_Client = (sBatchDetailObj, setBatchDetailErrorMsg) => {
  let iResp = true;
  // BatchDetail_SrNo: number;
  // BatchDetail_BatchNo: number;
  // BatchDetail_MFDate: Date;
  // BatchDetail_ExpDate: Date;
  // BatchDetail_Qty: number;
  // BatchDetail_Unit: string;
  // BatchDetail_PackQty: number;
  // BatchDetail_BaseQty: number;

  if (sBatchDetailObj.BatchDetail_SrNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_SrNo: "Sr.No should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BatchNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BatchNo: "Batch.No should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_MFDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_MFDate: "MFDate should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_ExpDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_ExpDate: "ExpDate should not be zero",
    }));
    iResp = false;
  }
  if (
    sBatchDetailObj.BatchDetail_Qty === "" ||
    sBatchDetailObj.BatchDetail_Qty <= 0
  ) {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Qty: "Qty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_Unit === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Unit: "Unit should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_PackQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_PackQty: "PackQty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BaseQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BaseQty: "BaseQty should not be zero",
    }));
    iResp = false;
  }
  return iResp;
};
//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", sItemSearch);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.Type?.response?.data?.message
        ? vItemSearch?.Type?.response?.data?.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit,
  SetIncentiveGroups,
  setOtherSlabs,
  setSupervisorSlabs,
  sDefZeroTaxCode,
  sDefZeroCessCode
) => {
  const { HeadObject } = InboundGrn();
  const { DBKernObj } = KernCAConfig();
  const { tax1, tax2 } = vRdxtax();
  if (vItemSearchFull.length > 0) {
    let iTax =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroTaxCode
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroCessCode
        : vItemSearchFull[0].TaxDept2;

    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      B_TaxDept: vRdxGRNtax1arr?.UId,
      B_TaxDept2: vRdxGRNtax2arr?.UId,
      B_TaxPerc: vRdxGRNtax1arr?.Perc,
      B_TaxPerc2: vRdxGRNtax2arr?.Perc,
      SuppRefNo1: vItemSearchFull[0].SuppRefNo1,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);
   
      let iUnit = vItemSearchFull[0]?.DefUnit || "";

      if (!iUnit) {
        iUnit = vItemSearchFull[0]?.PurUOM || "";
      }
     

      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });

      if (!vItemUnitSet) {
        iUnit = currentUnitArr[0]?.Unit || "";

        vItemUnitSet = currentUnitArr.find((obj) => {
          return obj.Unit === iUnit;
        });
      }
     await Unit_Onchange_001(
            iUnit,
            vItemUnitSet,
            vItemSearchFull[0]?.ItmCd,
            vRdxGRNtax1arr?.Perc,
            vRdxGRNtax2arr?.Perc,
             setBufferObj,
             sBufferObj
          );
    
   
   
    if (
      vRdxWmsHead.InboundType == "SALES_RETURN" &&
      DBKernObj.SONAS_INVOICE?.Val === "Y"
    ) {
      // GetIncentiveGroup
      const vIncentiveGroups = await GetIncentiveGroup(
        vItemSearchFull[0].ItmCd,
        vRdxWmsHead.A_Loc,
        SetIncentiveGroups
      );

      if (vIncentiveGroups.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_IncGroup: vIncentiveGroups[0].UId,
          B_SuprvPerc: vIncentiveGroups[0].SuprvPerc,
          B_OthersPerc: vIncentiveGroups[0].OthersPerc,
        }));
      }
      const vOtherSlabs = await GetOtherSlabs(setOtherSlabs);
      if (vOtherSlabs.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_SLANOther: vOtherSlabs[0],
        }));
      }
      const vSupervisorSlabs = await GetSupervisorSlabs(setSupervisorSlabs);
      if (vSupervisorSlabs.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_SLANSuprv: vSupervisorSlabs[0],
        }));
      }
    }

   
    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};
 export const Unit_Onchange_001 = async (
    xUnit='',
    xUnitObj={},
    xItemCode ='',
    iTax1Perc='',
    iTax2Perc='',
    setBufferObj=()=>{},
    sBufferObj={}
  ) => { 
     const { HeadObject } = InboundGrn();
    //by sir
    if (!!xUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        B_Unit: xUnitObj.Unit,
        B_UnitName: xUnitObj.Name1,
        B_PackQty: xUnitObj.PackQty,
      })); 
    }

   let currentUnitRateArr = await GetUnitRateArr(
      xItemCode,
      xUnit,
      HeadObject?.A_Party,
      HeadObject?.A_Loc,
      HeadObject?.A_RefDocTyp,
      HeadObject?.A_RefDocNo
    );

    let currentUnitRateObj = {
      B_URateFc: 0,
      B_LDiscPerc: 0,
      AddCess: 0,
      SplDiscAmt: 0,
      B_ExciseTaxAmt: 0,
    };

    if (currentUnitRateArr.length > 0) {
      currentUnitRateObj = {
        B_URateFc: currentUnitRateArr[0].CostLc,
        B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
        AddCess: currentUnitRateArr[0].AddiCess,
        SplDisc: currentUnitRateArr[0].SplDiscAmt,
        B_ExciseTaxAmt: currentUnitRateArr[0].ExciseAmt,
      };
      setBufferObj((obj) => ({
        ...obj,
        B_URateFc: currentUnitRateArr[0].CostLc,
        B_LDiscPerc: currentUnitRateArr[0].DiscPerc,
        AddCess: currentUnitRateArr[0].AddiCess,
        SplDisc: currentUnitRateArr[0].SplDiscAmt, //by sir
        B_ExciseTaxAmt: currentUnitRateArr[0].ExciseAmt,
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        B_URateFc: 0,
        B_LDiscPerc: 0,
        AddCess: 0,
        SplDiscAmt: 0,
        B_ExciseTaxAmt: 0,
      }));
    }
 
  let {
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    } = fCalculate_Detail(
      sBufferObj.B_Qty,
      xUnitObj.PackQty,
      HeadObject.A_ExRate,
      currentUnitRateObj.B_URateFc,
      currentUnitRateObj.B_LDiscPerc,
      sBufferObj.B_TDiscPerc,
      sBufferObj.B_FocFlag,
      currentUnitRateObj.B_ExciseTaxAmt,
      iTax1Perc,
      iTax2Perc,
      currentUnitRateObj.AddCess,
      0,
      sBufferObj.SplDiscPerc
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty,
      B_URateLc,
      B_GrossAmt,
      B_LDiscAmt,
      B_TDiscAmt,
      B_FocAmt,
      B_ExciseTaxNetAmt,
      B_NetAmt,
      B_TaxAmt,
      B_TaxAmt2,
      B_Rounding,
      B_NetAddCess,
      B_LandVal,
      SplDiscAmt,
    }));

    
  };
const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
const { HeadObject } = InboundGrn();
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
    v_Vendor:HeadObject.A_Party || ""
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  xRoundingValue = "",
  setDetailGridData,
  setFooterObj,
  xVocTyp
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var iGrossAmt = 0,
      iTDiscAmt = 0,
      iLDiscAmt = 0,
      iFocAmt = 0,
      iExciseTaxNetAmt = 0,
      iTaxAmt = 0,
      iTaxAmt2 = 0,
      iAddCess = 0,
      iSplDiscAmt1 = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      iGrossAmt += iSIDetail[i].B_GrossAmt;
      iTDiscAmt += iSIDetail[i].B_TDiscAmt;
      iLDiscAmt += iSIDetail[i].B_LDiscAmt;
      iFocAmt += iSIDetail[i].B_FocAmt;
      iExciseTaxNetAmt += iSIDetail[i].B_ExciseTaxNetAmt;
      iTaxAmt += iSIDetail[i].B_TaxAmt;
      iTaxAmt2 += iSIDetail[i].B_TaxAmt2;
      iAddCess += iSIDetail[i].B_NetAddCess;
      iSplDiscAmt1 += iSIDetail[i].SplDiscAmt1;
    }

    let iLandVal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      iTaxAmt +
      iTaxAmt2 +
      iAddCess +
      iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: iGrossAmt.toFixed(2),
      A_TDiscAmt: iTDiscAmt.toFixed(2),
      A_LDiscAmt: iLDiscAmt.toFixed(2),
      A_FocAmt: iFocAmt.toFixed(2),
      A_NetExcise: iExciseTaxNetAmt.toFixed(2),
      A_Tax: iTaxAmt.toFixed(2),
      A_Tax2: iTaxAmt2.toFixed(2),
      A_AddCess: iAddCess.toFixed(2),
      A_LandVal: iLandVal.toFixed(2),
      A_SplDiscAmt1: iSplDiscAmt1.toFixed(2),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: 0,
      A_TDiscAmt: 0,
      A_LDiscAmt: 0,
      A_FocAmt: 0,
      A_NetExcise: 0,
      A_Tax: 0,
      A_Tax2: 0,
      A_AddCess: 0,
      A_LandVal: 0,
      A_SplDiscAmt1: 0,
    }));
  }
};

const fCloseRefDocSearchModal = (
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj
) => {
  setRefDocSearchModal(false);
  fRefDocClearSimpleSearch();
  setRefDocModalArr([]);
  setRefDocModelObj({
    AnyData: "",
    Name: "",
    Code: "",
  });
};
const fReset_Linewise_Rebate = (setBufferObj) => {
  setBufferObj((obj) => ({
    ...obj,
    RebateType: "",
    ReduceCost: "N",
    SplDiscPerc: 0,
    SplDiscAmt: 0,
  }));
};

const fBuyer_or_SalesMan = async (
  xInboundType,
  setBuyer,
  dispatch,
  xLoc,
  xVocType,
  xVocNo
) => {
  if (xInboundType == "SALES_RETURN") {
    let vSalesMan = await GetSalesman(dispatch);
    if (vSalesMan.length > 0) {
      dispatch(
        Set_InboundGRN_HeadObject_A_Buyer({
          A_Buyer: vSalesMan[0]?.UId,
        })
      );
      setBuyer(vSalesMan);
    } else {
      setBuyer([]);
    }
  } else {
    let vBuyer = await GetBuyer(xLoc, xVocType, xVocNo, dispatch);

    if (vBuyer.length > 0) {
      dispatch(
        Set_InboundGRN_HeadObject_A_Buyer({
          A_Buyer: vBuyer[0]?.UId,
        })
      );
      setBuyer(vBuyer);
    } else {
      setBuyer([]);
    }
  }
};
const fBuyer_or_SalesMan_Arr = async (
  xInboundType,
  setBuyer,
  dispatch,
  xLoc,
  xVocType,
  xVocNo
) => {
  if (xInboundType === "SALES_RETURN") {
    let vSalesMan = await GetSalesman(dispatch);
    if (vSalesMan.length > 0) {
      setBuyer(vSalesMan);
    } else {
      setBuyer([]);
    }
  } else {
    let vBuyer = await GetBuyer(xLoc, xVocType, xVocNo, dispatch);
    if (vBuyer.length > 0) {
      setBuyer(vBuyer);
    } else {
      setBuyer([]);
    }
  }
};
//GCSimpleSearch for Ref Doc Modal
const fRefDocRowClick = async (
  e,
  dispatch,
  vRdxWmsHead,
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj,
  setBufferObj,
  setBuyer
) => {
  dispatch(
    Set_WmsInboundGRN_HeadObject_Set({
      ...vRdxWmsHead,
      A_RefDocTyp: e?.row?.VocTyp,
      A_RefDocTypName: e?.row?.VocName,
      A_RefDocNo: e?.row?.VocNo,
      A_Party: e?.row?.Vendor,
      A_PartyName: e?.row?.PartyName,
      InboundType: e?.row?.Source,
      UnloadingBay: e?.row?.LDPay,
      UnloadingBayName: e?.row?.LDPayName,
      A_PostDt: e?.row?.GRNDate,
      A_RefNo: e?.row?.RefNo,
      A_RefDt: e?.row?.RefDate,
      VendorInvAmount: e?.row?.InvAmt,
      A_RefDocVer: e?.row?.SrNo,
    })
  );
  fReset_Linewise_Rebate(setBufferObj);
  fBuyer_or_SalesMan(
    e?.row?.Source,
    setBuyer,
    dispatch,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_VocTyp,
    vRdxWmsHead.A_VocNo
  );
  GetDefcustomersetting(
    e?.row?.Vendor,
    vRdxWmsHead.A_Loc,
    e?.row?.Source,
    dispatch
  );
  GetDefaultDrCrAccount(
    vRdxWmsHead.A_VocTyp,
    vRdxWmsHead.A_PayMode,
    e?.row?.Vendor,
    dispatch
  );
  // setRefDocModalArr([]);
  setTimeout(() => {
    document.getElementsByName("B_ItmName")[0]?.focus();
  }, 500);
  fCloseRefDocSearchModal(
    setRefDocSearchModal,
    fRefDocClearSimpleSearch,
    setRefDocModalArr,
    setRefDocModelObj
  );
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

const fDefaultPayload = (xPaymode, dispatch) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode; //by client
  let DefaultPayload = {
    currentPayMode: iPaymode,
    PaymodeEnable: false,
  };
  if (xPaymode == "BOTH") {
    DefaultPayload.PaymodeEnable = false;
  } else {
    DefaultPayload.PaymodeEnable = true;
  }

  dispatch(
    Set_InboundGRN_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return DefaultPayload;
};
const fDiscFlagDependency = (xInboundType, dispatch) => {
  if (xInboundType != "VENDOR_INV") {
    dispatch(
      Set_InboundGRN_HeadObject_DiscFlag({
        A_DiscFlag: "Y",
      })
    );
  }
};

//HEAD LOADING API
// Api

//GET_API_Buyer
const GetBuyer = async (xloc, xvocTyp, xvocNo, dispatch) => {
  let iBuyerObj = {
    loc: xloc,
    trnTyp: sTrnTyp,
    vocTyp: xvocTyp,
    vocNo: xvocNo,
  };
  const iBuyer = await fExecuteAPI("GRN_BUYER_GETROW_001", iBuyerObj);

  if (iBuyer?.Type?.toUpperCase() === "SUCCESS") {
    return iBuyer.ResultSet.length > 0 ? iBuyer.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iBuyer.response.data.Status
        ? iBuyer.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};
//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API DEFAULTDRCRACCOUNT_GETROW
const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty, dispatch) => {
  const { HeadObject } = InboundGrn();
  let vDefaultDrCrAccountObj = {
    process: sTrnTyp,
    voucher: xVocTyp,
    paymode: xPayMode,
    party: xParty,
    Type: HeadObject.InboundType,
    Loc: HeadObject.A_Loc,
  };
  const vDefaultDrCrAccount = await fExecuteAPI(
    "DEFAULTDRCRACCOUNT_GETROW",
    vDefaultDrCrAccountObj
  );
  if (vDefaultDrCrAccount?.Type?.toUpperCase() === "SUCCESS") {
    if (vDefaultDrCrAccount?.ResultSet?.length > 0) {
      dispatch(
        Set_InboundGRN_HeadObject_DrCrAccount({
          A_CrAc: !!vDefaultDrCrAccount.ResultSet[0]?.CrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAc
            : "",
          A_CrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            : "",
          A_DrAc: !!vDefaultDrCrAccount.ResultSet[0]?.DrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAc
            : "",
          A_DrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            : "",
        })
      );
    }
  } else {
    fAlertToast("FAILED", vDefaultDrCrAccount.Message);
  }
};

//API GRN_INV02RCVNGSCSEARCH_GETROW
const GetRefDocInbound = async (
  xAnyData,
  xCode,
  xName,
  setHeaderSearchResultArr
) => {
  let vHeaderSearchObj = {
    v_RefDocNo: xAnyData,
    v_InvoiceNo: xCode,
    v_GrnDocNo: xName,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_INV02RCVNGSCSEARCH_GETROW",
   
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};
const GetdRefNoV2 = async (
  v_VocTyp,
  v_VocNo,
  v_SrNo,
  setHeaderSearchResultArr
) => {
  let vHeaderSearchObj = {
    v_VocTyp: v_VocTyp,
    v_VocNo: v_VocNo,
    v_SrNo: v_SrNo,
  };
 
  const vHeaderSearch = await fExecuteAPI( 
    "GRN_RefSearchSearch_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  const UnitInfo = await fExecuteAPI("GETITEMUNITSINBOUND_GETROW", itemUnitobj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo?.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo?.Type?.response?.data?.message
        ? UnitInfo?.Type?.response?.data?.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const GetIncentiveGroup = async (xB_Itmcd, xA_Loc, SetIncentiveGroups) => {
  let vIncentiveGroupsObj = {
    itemCd: xB_Itmcd,
    loc: xA_Loc,
  };
  const vIncentiveGroups = await fExecuteAPI(
    "INCENTIVEGROUP_GETROW",
    vIncentiveGroupsObj
  );
  if (vIncentiveGroups?.Type?.toUpperCase() === "SUCCESS") {
    if (vIncentiveGroups?.ResultSet?.length > 0) {
      SetIncentiveGroups(vIncentiveGroups.ResultSet);
      return vIncentiveGroups.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vIncentiveGroups?.Type?.response?.data?.message
        ? vIncentiveGroups?.Type?.response?.data?.message
        : "Error in vIncentiveGroups"
    );
    return [];
  }
};
const GetSupervisorSlabs = async (xsetSupervisorSlabs) => {
  const vSupervisorSlabs = await fExecuteAPI("SUPERVISORSLABS_GETROW");
  if (vSupervisorSlabs?.Type?.toUpperCase() === "SUCCESS") {
    xsetSupervisorSlabs(vSupervisorSlabs?.ResultSet);
    return vSupervisorSlabs?.ResultSet;
  } else {
    fAlertToast("FAILED", vSupervisorSlabs?.Message);
    return [];
  }
};

const GetOtherSlabs = async (setOtherSlabs) => {
  const vOtherSlabs = await fExecuteAPI("OTHERSLABS_GETROW");
  if (vOtherSlabs?.Type?.toUpperCase() === "SUCCESS") {
    setOtherSlabs(vOtherSlabs?.ResultSet);
    return vOtherSlabs.ResultSet;
  } else {
    fAlertToast("FAILED", vOtherSlabs.Message);
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", vItemLineObj);
  if (ItemLineInfo?.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo?.Type?.response?.data?.message
        ? ItemLineInfo?.Type?.response?.data?.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  const UnitRateInfo = await fExecuteAPI(
    "INBOUNDUNITRATE_GETROW",
    vUnitRateObj
  );
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo?.ResultSet?.length > 0) {
      return UnitRateInfo?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo?.Type?.response?.data?.message
        ? UnitRateInfo?.Type?.response?.data?.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    vItemFullSearchDataObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull?.ResultSet?.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    VocTyp: !!xVocTyp ? xVocTyp : "",
    VocNo: !!xB_VocNo ? xB_VocNo : "",
    SrNo: xB_Srno,
  };
  const iSIDetailResult = await fExecuteAPI(
    "GRN_GET_DETAIL_GETROW_001",
    iSIDetailObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult?.ResultSet?.length > 0) {
      return iSIDetailResult?.ResultSet;
    } else {
      return [];
    }
  }
};

//API GETITEMATTRIBUTES_GETROW
const fValidateItemsAttributes = async (sBufferObj, setErrorMsgDetail) => {
  const { HeadObject } = InboundGrn();
  const vRdxUserInfoObj = vRdxUserInfo();
  let vItemAttributesObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
  };
  const vItemAttributes = await fExecuteAPI(
    "GETITEMATTRIBUTES_GETROW",
    vItemAttributesObj
  );

  if (
    vItemAttributes?.Type?.toUpperCase() === "SUCCESS" &&
    vItemAttributes?.ResultSet?.length > 0
  ) {
    let vGetItemAttributes = vItemAttributes.ResultSet[0];
    let iRes = true;

    if (vGetItemAttributes.Linking != "") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_Itmcd: vGetItemAttributes.Linking,
      }));
      iRes = false;
    }

    if (vGetItemAttributes.ItmActive == "N") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_ItmName: "Item is in-actived",
      }));
      iRes = false;
    }

    // if (vGetItemAttributes.Stock - sBufferObj.B_BaseQty < 0) {
    //     fAlertToast("FAILED", "Qty exceed than Available stock " + vGetItemAttributes.Stock.toFixed(2));
    //     iRes = false
    // }

    if (vGetItemAttributes.TaxDept1 != sBufferObj.B_TaxDept) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept: "Tax code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc1 != sBufferObj.B_TaxPerc) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc: "Tax % is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxDept2 != sBufferObj.B_TaxDept2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept2: "Cess code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc2 != sBufferObj.B_TaxPerc2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc2: "Cess % is not matching",
      }));
      iRes = false;
    }

    return { iRes, vGetItemAttributes };
  } else {
    fAlertToast("FAILED", "GETITEMATTRIBUTES_GETROW");
  }
};

//API VALIDATIONDETAILINFO_GETROW
const fGetValidationDetailInfo = async (
  sBufferObj,
  ErrorMsgDetail,
  setErrorMsgDetail
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = InboundGrn();
  const { DBKernObj } = KernCAConfig();

 
  let incentiveGroupAllow = false;
  if (DBKernObj.SONAS_INVOICE) {
    incentiveGroupAllow =
      HeadObject.InboundType == "SALES_RETURN" && DBKernObj.SONAS_INVOICE?.Val === "Y"
        ? true
        : false;
  }

  let vResp = true;
  let vValidationDetailInfoObj = {
    trnTyp: sTrnTyp,
    vocTyp: HeadObject.A_VocTyp,
    vocNo: HeadObject.A_VocNo,
    B_Srno: sBufferObj.B_Srno,
    userCd: vRdxUserInfoObj.UserID,
    B_Itmcd: sBufferObj.B_Itmcd,
    unit: sBufferObj.B_Unit,
    A_Loc: HeadObject.A_Loc,
    landAmt: sBufferObj.B_LandVal,
    B_Qty: sBufferObj.B_Qty,
    refDoctyp: HeadObject.A_RefDocTyp,
    refDocName: HeadObject.A_RefDocTypName,
    refDocNo: HeadObject.A_RefDocNo,
    party: HeadObject.A_Party,
    B_IncGroup: incentiveGroupAllow ? sBufferObj.B_IncGroup : "N",
    B_BaseQty: sBufferObj.B_BaseQty,
    B_CI: sBufferObj.B_CI,
    A_INV_TYPE: "",
  };
  const vValidationDetailInfo = await fExecuteAPI(
    "VALIDATIONDETAILINFO_GETROW",
    fcheck_null_undefine_replace_empty(vValidationDetailInfoObj)
  );
  if (vValidationDetailInfo?.Type?.toUpperCase() == "SUCCESS") {
    vResp = true;
  } else {
    if (vValidationDetailInfo?.Type?.toUpperCase() == "SUCCESS") {
      vResp = true;
    } else if (vValidationDetailInfo?.response?.status == 400) {
      let isKeyAvailable =
        vValidationDetailInfo?.response?.data?.ResultSet?.field in
        ErrorMsgDetail;
      if (isKeyAvailable) {
        setErrorMsgDetail((obj) => ({
          ...obj,
          [vValidationDetailInfo.response.data.ResultSet.field]:
            vValidationDetailInfo.response.data.Status,
        }));
      } else {
        if (vValidationDetailInfo.response.data.Status) {
          fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
        } else {
          fAlertToast("FAILED", "vValidationDetailInfo.response.data.Status");
        }
      }
      return (vResp = false);
    } else if (vValidationDetailInfo.response.status == 500) {
      fAlertToast("FAILED", vValidationDetailInfo.response.data.Status);
      return (vResp = false);
    }
    return (vResp = false);
  }
  return vResp;
};

//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  fOpenBatchModal,
  setBatchUnit,
  setBatchObj,
  setBatchDetailObj,
  setBuyer,
  xDocStatus = "POST",
  fNavigateToNotification
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = InboundGrn();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post

  let vSaveSIHeadObj = {
    A_VocTyp: HeadObject.A_VocTyp,
    A_VocNo: HeadObject?.A_VocNo,
    A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefDt: moment(HeadObject.A_RefDt).format("MM/DD/YYYY"),
    A_RefNo: HeadObject.A_RefNo,
    A_Party: HeadObject.A_Party,
    A_Curr: HeadObject.A_Curr,
    A_ExRate: HeadObject.A_ExRate,
    A_PayMode: HeadObject.A_PayMode,
    A_Type: HeadObject.A_Type,
    A_Loc: HeadObject.A_Loc,
    A_Buyer: HeadObject.A_Buyer,
    A_Narr: HeadObject.A_Narr,
    A_CrAc: HeadObject.A_CrAc,
    A_DrAc: HeadObject.A_DrAc,
    A_DiscPerc: HeadObject?.A_DiscPerc,
    A_DiscFlag: HeadObject?.A_DiscFlag,
    A_Rounding: HeadObject?.A_Rounding,
    A_LC: HeadObject.A_LC,
    A_Charges1: HeadObject.A_Charges1,
    A_DocStat: iStatus,
    A_RefNo4: HeadObject.VendorInvAmount,
    IP: vRdxUserInfoObj.IP,
    UserId: vRdxUserInfoObj.UserID,
    A_Taxable: HeadObject.A_Taxable,
    A_CUSTFIELD2:
      HeadObject.InboundType == "SALES_RETURN" ? HeadObject.salesGroup : "",
    A_CUSTFIELD3: HeadObject.TaxType,
    A_CUSTFIELD4: HeadObject.A_CUSTFIELD4,
    A_CUSTFIELD5: HeadObject.UnloadingBay,
    A_CUSTFIELD6: HeadObject.InboundType,
    A_CUSTFIELD7: HeadObject.offer,
    A_RefDocTyp: HeadObject.A_RefDocTyp,
    A_RefDocNo: HeadObject.A_RefDocNo,
    A_RefDocVer: HeadObject.A_RefDocVer,
    A_CUSTFIELD9: HeadObject.A_CUSTFIELD9,
    A_PutAway: HeadObject.A_PutAway, // Y/N
    A_AutoBatch: HeadObject.A_AutoBatch, // Y/N
    virtualBin: HeadObject?.virtualBin,
    A_TeleUser:  HeadObject.InboundType == "SALES_RETURN"  && userBasedHideField() ?HeadObject?.TeleUser ||"": "",
    // A_LCust: "",
    // A_INV_TYPE: "",
  };
  const vSaveSIHead = await fExecuteAPI(
    "GRN_SAVE_HEAD_GETROW_001",
    vSaveSIHeadObj
  );
  if (vSaveSIHead.Type == "SUCCESS") {
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.A_VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_InboundGRN_HeadObject_A_VocNo({
        A_VocNo: xSave
          ? vSaveSIHead?.ResultSet[0]?.A_VocNo
          : HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(
        HeadObject.A_VocTyp,
        xSave ? vSaveSIHead?.ResultSet[0]?.A_VocNo : HeadObject.A_VocNo,
        dispatch,
        fNewDetail,
        setBuyer
      );
      // WMINV03_CostUpdate_GETROW
      setTimeout(() => {
        GetCostUpdate(sTrnTyp, HeadObject?.A_VocTyp, HeadObject?.A_VocNo);
      }, 200);
      fAlertToast("SUCCESS", "Successfully posted");

      fNavigateToNotification();
    } else {
      fSaveDetail(
        vSaveSIHead.ResultSet[0].A_VocNo,
        sBufferObj,
        fNewDetail,
        fOpenBatchModal,
        setBatchUnit,
        setBatchObj,
        setBatchDetailObj
      );
    }
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail, setBuyer) => {
  const { HeadObject } = InboundGrn();
  let vSIHeadObj = {
    A_VocTyp: xA_VocTyp,
    A_VocNo: A_VocNo,
  };
  const vSIHead = await fExecuteAPI("GRN_GET_HEAD_GETROW_001", vSIHeadObj);
  
  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_WmsInboundGRN_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_PostDt,
        A_RefDt: vSIHead.ResultSet[0].A_RefDt,
        A_RefNo: vSIHead.ResultSet[0].A_RefNo,
        A_Party: vSIHead.ResultSet[0].A_Party,
        A_PartyName: vSIHead.ResultSet[0].PartyName,
        A_Curr: vSIHead.ResultSet[0].A_Curr,
        A_Currname: vSIHead.ResultSet[0].CurrName,
        A_ExRate: vSIHead.ResultSet[0].A_ExRate,
        A_PayMode: vSIHead.ResultSet[0].A_PayMode,
        A_Type: vSIHead.ResultSet[0].A_Type,
        A_Loc: vSIHead.ResultSet[0].A_Loc,
        A_Buyer: vSIHead.ResultSet[0].A_Buyer, ////SalesMan
        A_Narr: vSIHead.ResultSet[0].A_Narr,
        A_CrAc: vSIHead.ResultSet[0].A_CrAc,
        A_CrAcName: vSIHead.ResultSet[0].CrAcName,
        A_DrAc: vSIHead.ResultSet[0].A_DrAc,
        A_DrAcName: vSIHead.ResultSet[0].DrAcName,
        A_DiscPerc: vSIHead.ResultSet[0].A_DiscPerc
          ? vSIHead.ResultSet[0].A_DiscPerc
          : 0,
        A_Rounding: vSIHead.ResultSet[0].A_Rounding
          ? vSIHead.ResultSet[0].A_Rounding
          : 0,
        A_DocStat: vSIHead.ResultSet[0].A_DocStat,
        salesGroup:
          vSIHead.ResultSet[0].A_CUSTFIELD6 == "SALES_RETURN"
            ? vSIHead.ResultSet[0].A_CUSTFIELD2
            : "", //SalesGroup dispatch only if inbound type == sales_return
        TaxType: vSIHead.ResultSet[0].A_CUSTFIELD3,
        A_TaxGross: vSIHead.ResultSet[0].A_TaxGross,
        A_Taxable: vSIHead.ResultSet[0].A_Taxable,
        A_Br: vSIHead.ResultSet[0].A_Br, //LocationBrCode
        // A_BrName: "", //location branchName
        // A_LocName: "",
        // A_Buyername: "",
        A_GrossAmt: vSIHead.ResultSet[0].A_GrossAmt, //decimal
        A_DiscAmt: vSIHead.ResultSet[0].A_DiscAmt, //decimal
        A_DiscFlag: vSIHead.ResultSet[0].A_DiscFlag,
        A_TaxAmt: vSIHead.ResultSet[0].A_TaxAmt, //decimal
        A_NetAmt: vSIHead.ResultSet[0].A_NetAmt, //decimal
        A_LC: vSIHead.ResultSet[0].A_LC, //decimal
        A_Charges1: vSIHead.ResultSet[0].A_Charges1, //decimal
        // A_Charges2: 0, //decimal    // INTRN001->VAT		INTRN002->INTER COMPANY  INTRN002->IMPORT
        // A_CUSTFIELD3Name: "",
        A_CUSTFIELD4: vSIHead.ResultSet[0].A_CUSTFIELD4,
        UnloadingBay: vSIHead.ResultSet[0].A_CUSTFIELD5, // Unloading Bin ID
        // UnloadingBayName: "", // Unloading Bin Name
        InboundType: vSIHead.ResultSet[0].A_CUSTFIELD6, // From     // VENDOR_INV->Vendor		TRANSFER_RETURN->Outlet		SALES_RETURN ->Sales Return
        // A_CUSTFIELD8: "",
        // A_CUSTFIELD9: "",
        // A_ExciseTaxNetAmt: 0, //Decimal
        // A_ScaleItm: "N",
        // A_TCS: 0, //Decimal
        // Source: "",
        A_RefDocTyp: vSIHead.ResultSet[0].A_RefDocTyp,
        A_RefDocTypName: vSIHead.ResultSet[0].RefDocTypName,
        A_RefDocNo: vSIHead.ResultSet[0].A_RefDocNo,
        A_RefDocVer: vSIHead.ResultSet[0].A_RefDocVer, //Int
        VendorInvAmount: vSIHead.ResultSet[0].A_RefNo4, //INvoice Amount
        offer:vSIHead.ResultSet[0].A_CUSTFIELD7 == "" || vSIHead.ResultSet[0].A_CUSTFIELD7 == null?"N": vSIHead.ResultSet[0].A_CUSTFIELD7, // Offer Y/N
        A_PutAway: vSIHead.ResultSet[0].A_PutAway, // Y/N
        A_AutoBatch: vSIHead.ResultSet[0].A_AutoBatch, // Y/N
        virtualBin: vSIHead.ResultSet[0]?.VirtualBin,
        TeleUser:vSIHead.ResultSet[0]?.Tele_User||""
      })
    );
    fDiscFlagDependency(vSIHead.ResultSet[0].A_CUSTFIELD6, dispatch);
    // ItemsAliasListSearch(vSIHead.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

    // fBuyer_or_SalesMan(
    //   vSIHead.ResultSet[0].A_CUSTFIELD6,
    //   setBuyer,
    //   dispatch,
    //   vSIHead.ResultSet[0].A_Loc,
    //   vSIHead.ResultSet[0].A_VocTyp,
    //   vSIHead.ResultSet[0].A_VocNo
    // );

    // GetDefaultDrCrAccount(
    //   vSIHead.ResultSet[0].A_VocTyp,
    //   vSIHead.ResultSet[0].A_PayMode,
    //   vSIHead.ResultSet[0].A_Party,
    //   dispatch
    // );

    fNewDetail(
      vSIHead.ResultSet[0].A_VocNo,
      vSIHead.ResultSet[0].A_Rounding,
      vSIHead.ResultSet[0].A_VocTyp,
      vSIHead?.ResultSet[0]?.A_CUSTFIELD3
    );
  }
};

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();
 
  const iShowField = DBKernObj.MULT_CARD_ID?.Val === "Y";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
//API SAVESIDETAIL_GETROW
const fSaveDetail = async (
  xB_VocNo,
  sBufferObj,
  fNewDetail,
  fOpenBatchModal,
  setBatchUnit,
  setBatchObj,
  setBatchDetailObj
) => {
  const { HeadObject } = InboundGrn();
  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_CI: sBufferObj?.B_CI,
    B_Unit: sBufferObj.B_Unit,
    B_URateFc: sBufferObj.B_URateFc,
    B_URateLc: sBufferObj.B_URateLc,
    B_GrossAmt: sBufferObj.B_GrossAmt,
    B_LDiscPerc: sBufferObj.B_LDiscPerc,
    B_LDiscAmt: sBufferObj.B_LDiscAmt,
    B_FocFlag: sBufferObj.B_FocFlag,
    B_AprmtFlag: sBufferObj.B_AprmtFlag,
    B_RefDocTyp: HeadObject.A_RefDocTyp,
    B_RefDocNo: HeadObject.A_RefDocNo,
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo5: 0,
    B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
    B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
    B_TaxPerc: sBufferObj.B_TaxPerc,
    B_TaxAmt: sBufferObj.B_TaxAmt,
    SplDiscAmt1: sBufferObj.SplDisc,
    SplDiscAmt2: sBufferObj.SplDiscPerc,
    SplDiscAmt3: sBufferObj.SplDiscAmt,
    Field1: 0,
    Field2: 0,
    Field6: sBufferObj.RebateType,
    Field7: sBufferObj.ReduceCost,
    Field8: sBufferObj?.Narration,
    Field9: "",
    Field10: "",
    B_TaxDept: sBufferObj.B_TaxDept,
    B_TaxDept2: sBufferObj.B_TaxDept2,
    B_TaxPerc2: sBufferObj.B_TaxPerc2,
    B_TaxAmt2: sBufferObj.B_TaxAmt2,
    B_IncGroup: sBufferObj.B_IncGroup,
    B_SuprvPerc: sBufferObj.B_SuprvPerc,
    B_OthersPerc: sBufferObj.B_OthersPerc,
    B_SLANSuprv: sBufferObj.B_SLANSuprv,
    B_SlabAmtSuprv: sBufferObj.B_SlabAmtSuprv,
    B_SLANOther: sBufferObj.B_SLANOther,
    B_SlabAmtOther: sBufferObj.B_SlabAmtOther,
    B_Ad_CessAmt: 0, //by sir
    B_Ad_PCQty: 0, //by sir
    B_Ad_PCRate: sBufferObj.AddCess,
    B_Ad_NetCessAmt: sBufferObj.B_NetAddCess,
    v_B_Pallet_Type: sBufferObj.PalletType,
  };

  const vSaveSIDetail = await fExecuteAPI(
    "GRN_SAVE_DETAIL_GETROW_001",
    vSaveSIDetailObj
  );
  if (vSaveSIDetail.Type?.toUpperCase() === "SUCCESS") {
    fOpenBatchModal(
      vSaveSIDetail.ResultSet[0].B_Srno,
      sBufferObj.B_BaseQty,
      sBufferObj.B_PackQty
    );
    setBatchObj((obj) => ({
      ...obj,
      SrNo: vSaveSIDetail.ResultSet[0].B_Srno,
      ItemCode: sBufferObj.B_Itmcd,
      ItemName: sBufferObj.B_ItmName,
      Qty: sBufferObj.B_Qty,
      Unit: sBufferObj.B_UnitName,
      BaseQty: sBufferObj.B_BaseQty,
    }));
    let vBatchUnit = await GetUnitArr(sBufferObj.B_Itmcd, setBatchUnit);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: sBufferObj.B_Unit,
      BatchDetail_Qty: 0,
      BatchDetail_PackQty: sBufferObj.B_PackQty,
      BatchDetail_BaseQty: 0,
    }));
    fNewDetail(
      xB_VocNo,
      HeadObject.A_Rounding,
      HeadObject?.A_VocTyp,
      HeadObject?.TaxType
    );
    if (vSaveSIDetail.ResultSet[0].isVariComp == "Y") {
      fAlertToast(
        "SUCCESS",
        "You have completed the variance and saved Successfully"
      );
    } else {
      fAlertToast("SUCCESS", "Successfully Saved");
    }
  }
};

//API "GetItemAttributesPurchase_GETROW"
const GetItemAttributesPurchase = async (dispatch, sBufferObj) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = InboundGrn();
  let vItemAttributesPurchaseObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
    party: HeadObject.A_Party,
    TrnTyp: sTrnTyp,
    PO_DocTyp: HeadObject.A_RefDocTyp,
    PO_DocNo: HeadObject.A_RefDocNo,
    UserCd: vRdxUserInfoObj.UserID,
    TaxDept1: sBufferObj?.B_TaxDept,
    TaxDept2: sBufferObj?.B_TaxDept2,
  };
  const vItemAttributesPurchase = await fExecuteAPI(
    "GetItemAttributesPurchase_GETROW",
    vItemAttributesPurchaseObj
  );
  if (vItemAttributesPurchase.Type?.toUpperCase() === "SUCCESS") {
    return vItemAttributesPurchase.ResultSet;
  } else {
    fAlertToast("FAILED", vItemAttributesPurchase?.response?.data?.Status);
    return [];
  }
};

//API  "PoQtyValidation_GETROW",
const GetPoQtyValidation = async (
  dispatch,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = InboundGrn();

  let vPoQtyValidationObj = {
    PoTyp: HeadObject.A_RefDocTyp,
    PoNo: HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: xB_Srno,
    ItmCd: xB_Itmcd,
    Qty: xB_Qty,
    Unit: xB_Unit,
  };

  const vPoQtyValidation = await fExecuteAPI(
    "PoQtyValidation_GETROW",
    vPoQtyValidationObj
  );
  if (vPoQtyValidation.Type?.toUpperCase() === "SUCCESS") {
    return vPoQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vPoQtyValidation?.response?.data?.Status);
    return [];
  }
};
export const SalesReturnLineItem_Validation = async (dispatch, sBufferObj) => {
  const { HeadObject } = InboundGrn();

  let iRespObj = {
    v_VocTyp: HeadObject.A_VocTyp,
    v_VocNo: HeadObject.A_VocNo,
    v_SrNo: sBufferObj.B_Srno,
    v_RefVocTyp: HeadObject.A_RefDocTyp,
    v_RefVocNo: HeadObject.A_RefDocNo,
    v_RefSrNo: HeadObject.A_RefDocVer,
    v_ItmCd: sBufferObj.B_Itmcd,
    v_Qty: sBufferObj.B_Qty,
    v_Unit: sBufferObj.B_Unit,
  };

  const iResp = await fExecuteAPI("SalesReturnLineItemValidation", iRespObj);
  console.log("asdasfda",iResp);
  if (iResp.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else  {   
    fAlertToast(
      "FAILED",
      iResp?.response?.data?.message || "Error in SalesReturnLineItem" 
    );
    return false;
  } 
};

//API  "TsrQtyValidation_GETROW",
const GetTsrQtyValidation = async (
  dispatch,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = InboundGrn();

  let vTsrQtyValidationObj = {
    PoTyp: HeadObject.A_RefDocTyp,
    PoNo: HeadObject.A_RefDocNo,
    GrnType: HeadObject.A_VocTyp,
    GrnNo: HeadObject.A_VocNo,
    SrNo: xB_Srno,
    ItmCd: xB_Itmcd,
    Qty: xB_Qty,
    Unit: xB_Unit,
  };

  const vTsrQtyValidation = await fExecuteAPI(
    "TsrQtyValidation_GETROW",
    vTsrQtyValidationObj
  );

  if (vTsrQtyValidation.Type?.toUpperCase() === "SUCCESS") {
    return vTsrQtyValidation.ResultSet;
  } else {
    fAlertToast("FAILED", vTsrQtyValidation?.response?.data?.Status);
    return [];
  }
};

//API  "GrnRefNoValidation_GETROW",
const GrnRefNoValidation = async (dispatch) => {
  const { HeadObject } = InboundGrn();
  let vGrnRefNoValidationObj = {
    TrnTyp: sTrnTyp,
    RefNo: HeadObject.A_RefDocNo,
    Vendor: HeadObject.A_Party,
    VocTyp: HeadObject.A_VocTyp,
    VocNo: HeadObject.A_VocNo,
  };
  const vGrnRefNoValidation = await fExecuteAPI(
    "GrnRefNoValidation_GETROW",
    vGrnRefNoValidationObj
  );
  if (vGrnRefNoValidation.Type?.toUpperCase() === "SUCCESS") {
    return vGrnRefNoValidation.ResultSet ? vGrnRefNoValidation.ResultSet : [];
  } else {
    fAlertToast("FAILED", vGrnRefNoValidation?.response?.data?.Status);
    return [];
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  const vTransTaxType = await fExecuteAPI(
    "TransTaxType_GETROW",
    vTransTaxTypeObj
  );
  if (vTransTaxType.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

//API SAVE_DETAIL_BATCH_GETROW_001
const GetSaveDetailBatch = async (sBatchObj, sBatchDetailObj, dispatch) => {
  const { HeadObject } = InboundGrn();
  // BatchDetail_SrNo: number;
  //   BatchDetail_BatchNo: number;
  //   BatchDetail_MFDate: Date;
  //   BatchDetail_ExpDate: Date;
  //   BatchDetail_Qty: number;
  //   : string;
  //   BatchDetail_PackQty: number;
  //   BatchDetail_BaseQty: number;
  let vSaveDetailBatchObj = {
    C_VocTyp: HeadObject.A_VocTyp,
    C_VocNo: HeadObject.A_VocNo,
    C_SrNo: sBatchObj.SrNo,
    C_ItmCd: sBatchObj.ItemCode,
    C_Qty: sBatchDetailObj.BatchDetail_Qty,
    C_Unit: sBatchDetailObj.BatchDetail_Unit,
    C_BaseQty: sBatchDetailObj.BatchDetail_BaseQty,
    C_Narr: "",
    C_BatchNo: sBatchDetailObj.BatchDetail_BatchNo,
    C_BatchDt: moment(sBatchDetailObj.BatchDetail_MFDate).format("MM/DD/YYYY"),
    C_ExpDt: moment(sBatchDetailObj.BatchDetail_ExpDate).format("MM/DD/YYYY"),
    C_PTyp1: "",
    C_PTyp2: "",
    C_PTyp3: 0,
    C_PTyp4: 0,
    C_PTyp5: 0,
    C_PTyp6: 0,
    C_RowID: sBatchDetailObj.BatchDetail_SrNo,
  };
  const vSaveDetailBatch = await fExecuteAPI(
    "SAVE_DETAIL_BATCH_GETROW_001",
    vSaveDetailBatchObj
  );
  if (vSaveDetailBatch.Type?.toUpperCase() === "SUCCESS") {
    fAlertToast("SUCCESS", "Successfully Saved");
    return vSaveDetailBatch?.Type;
  } else {
    fAlertToast("FAILED", "Batch not saved");
  }
};

//API DELETE_DETAIL_BATCH_GETROW_001
const GetDeleteDetailBatch = async (xSrNo, xRowId, dispatch) => {
  const { HeadObject } = InboundGrn();
  let vDeleteDetailBatchObj = {
    C_VocTyp: HeadObject.A_VocTyp,
    C_VocNo: HeadObject.A_VocNo,
    C_SrNo: xSrNo,
    C_RowID: xRowId,
  };
  const vDeleteDetailBatch = await fExecuteAPI(
    "DELETE_DETAIL_BATCH_GETROW_001",
    vDeleteDetailBatchObj
  );
  if (vDeleteDetailBatch.Type?.toUpperCase() === "SUCCESS") {
    fAlertToast("SUCCESS", "Successfully Deleted");
    return vDeleteDetailBatch.Type;
  } else {
    fAlertToast("FAILED", "Batch not Deleted");
    return [];
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const GetBatchDetail = async (xSrNo, dispatch) => {
  const { HeadObject } = InboundGrn();
  let vBatchDetailObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
    SrNo: xSrNo,
  };
  const vBatchDetail = await fExecuteAPI(
    "GET_BATCH_DETAILS_GETROW_001",
    vBatchDetailObj
  );
  if (vBatchDetail.Type?.toUpperCase() === "SUCCESS") {
    return vBatchDetail.ResultSet.length > 0 ? vBatchDetail.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      !!vBatchDetail?.response?.data?.message
        ? vBatchDetail?.response?.data?.message
        : "Errorn in loading batch"
    );
  }
};

//API WMINV03D_GetRow
const Get_Loaded_Cost_WMINV03D_GetRow = async (dispatch) => {
  const { HeadObject } = InboundGrn();
  let vLoadedCostObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  const vLoadedCost = await fExecuteAPI("WMINV03D_GetRow", vLoadedCostObj);
  if (vLoadedCost.Type?.toUpperCase() === "SUCCESS") {
    return vLoadedCost.ResultSet.length > 0 ? vLoadedCost.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      !!vLoadedCost?.response?.data?.message
        ? vLoadedCost?.response?.data?.message
        : "Errorn in loading loaded cost"
    );
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const Get_LoadedCost = async (xData, xType, xAcTyp, xExact, dispatch) => {
  const { HeadObject } = InboundGrn();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateHead_Server = async (dispatch, iSplDiscAmt1, xApprove) => {
  const { HeadObject } = InboundGrn();
  const vRdxUserInfoObj = vRdxUserInfo();
  const { DBKernObj } = KernCAConfig();

   
  let incentiveGroupAllow = false;
  if (!!DBKernObj.SONAS_INVOICE) {
    incentiveGroupAllow =
      HeadObject.InboundType == "SALES_RETURN" && DBKernObj.SONAS_INVOICE?.Val == "Y"
        ? true
        : false;
  }

  let vValidateHeadApproveObj = {
    xTrnTyp: sTrnTyp,
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xPostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    xLoc: HeadObject.A_Loc,
    xParty: HeadObject.A_Party,
    xUserCd: vRdxUserInfoObj?.UserID,
    xSalesGrp: incentiveGroupAllow ? HeadObject.salesGroup : "",
    xRefDocTyp: HeadObject.A_RefDocTyp,
    xRefDocNo: HeadObject.A_RefDocNo,
    xRefDocName: HeadObject.A_RefDocTypName,
    xRefVer: HeadObject.A_RefDocVer,
    xInboundType: HeadObject.InboundType,
    xOfferTrans: HeadObject.offer == "Y" ? true : false,
    xUserGrp: vRdxUserInfoObj?.UserGroupCode,
    xRebate: false,
    xBuyer: HeadObject.A_Buyer,
    xSplDiscAmt: 0, //by sir bcoz linerebatand spldisc same
    xFreight: HeadObject.A_LC,
    xCharges: HeadObject.A_Charges1,
    xDiscDistribution: HeadObject.A_DiscFlag == "Y" ? true : false,
    xDrAc: HeadObject.A_DrAc,
    xCrAc: HeadObject.A_CrAc,
    xLineRebatAmount: iSplDiscAmt1,
    xApprove: xApprove,
  };

  const vValidateHeadApprove = await fExecuteAPI(
    "VALIDATE_HEAD_WMINV03_GETROW",
    fcheck_null_undefine_replace_empty(vValidateHeadApproveObj)
  );
  if (vValidateHeadApprove.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else if (vValidateHeadApprove.Type === "FAILED") {
    fAlertToast(
      "FAILED",
      !!vValidateHeadApprove.Status
        ? vValidateHeadApprove.Status
        : "Error Validate Head Approve"
    );
    return false;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove.response.data.Status);

    return false;
  }
};

//API CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW
const GetCheckPOCreditNoteAmount = async (dispatch) => {
  const { HeadObject } = InboundGrn();
  let vCheckPOCreditNoteAmountObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  const vCheckPOCreditNoteAmount = await fExecuteAPI(
    "CHECK_PO_CREDIT_NOTE_AMOUNT_GETROW",
    vCheckPOCreditNoteAmountObj
  );
  if (vCheckPOCreditNoteAmount.Type?.toUpperCase() === "SUCCESS") {
    return vCheckPOCreditNoteAmount.ResultSet.length > 0
      ? vCheckPOCreditNoteAmount.ResultSet
      : [];
  } else if (vCheckPOCreditNoteAmount.response.status == 400) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  } else if (vCheckPOCreditNoteAmount.response.status == 500) {
    fAlertToast("FAILED", vCheckPOCreditNoteAmount.response.data.Status);
    return [];
  }
};

//API VALIDATE_COST_VARIANCE_GETROW
const GetValidateCostVariance = async (dispatch) => {
  const { HeadObject } = InboundGrn();
  const vRdxUserInfoObj = vRdxUserInfo();
  // let vValidateCostVarianceObj = {
  //   voctyp: "WG002",
  //   vocno: "GRSDC00211",
  //   usercd: "001",
  // };
  let vValidateCostVarianceObj = {
    voctyp: HeadObject?.A_VocTyp,
    vocno: HeadObject?.A_VocNo,
    usercd: vRdxUserInfoObj?.UserID,
  };
  const vValidateCostVariance = await fExecuteAPI(
    "VALIDATE_COST_VARIANCE_GETROW",
    vValidateCostVarianceObj
  );
  if (vValidateCostVariance.Type?.toUpperCase() === "SUCCESS") {
    return vValidateCostVariance.ResultSet.length > 0
      ? vValidateCostVariance.ResultSet
      : [];
  } else if (vValidateCostVariance.response.status == 400) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  } else if (vValidateCostVariance.response.status == 500) {
    fAlertToast("FAILED", vValidateCostVariance.response.data.Status);
    return [];
  }
};

//API SALESGROUP
const GetSalesGroups = async (xA_Loc) => {
  const vSalesGroups = await fExecuteAPI("SALESGROUPS_GETROW", xA_Loc);
  if (vSalesGroups.Type == "SUCCESS") {
    return vSalesGroups.ResultSet;
  } else {
    fAlertToast("FAILED", vSalesGroups.Message);
    return [];
  }
};

var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//defcustomersetting_GETROW
const GetDefcustomersetting = async (xAcCd, xLoc, xInboundType, dispatch) => {
  const { DBKernObj } = KernCAConfig();
  const { HeadObject } = InboundGrn();
 
  if (DBKernObj.SONAS_INVOICE?.Val === "Y" && xInboundType == "SALES_RETURN") {
    let vdefcustomersettingObj = {
      accd: xAcCd,
      loc: xLoc,
    };
    const vdefcustomersetting = await fExecuteAPI(
      "defcustomersetting_GETROW",
      vdefcustomersettingObj
    );
    if (vdefcustomersetting?.Type?.toUpperCase() == "SUCCESS") {
      if (
        vdefcustomersetting.ResultSet.length > 0 
      ) {
        dispatch(
          Wms_HeadObject_SalesGroup_SalesMan_Set({
            A_Buyer: !!vdefcustomersetting.ResultSet[0].SalesMan
              ? vdefcustomersetting.ResultSet[0].SalesMan|| ""
              : HeadObject.A_Buyer|| "",
            salesGroup: !!vdefcustomersetting.ResultSet[0].SalesGroup
              ? vdefcustomersetting.ResultSet[0].SalesGroup|| ""
              : HeadObject.salesGroup|| "",
          })
        );
      }
    } else {
      fAlertToast(
        "FAILED",
        !!vdefcustomersetting.Message
          ? vdefcustomersetting.Message
          : "Error in default setting customer"
      );
    }
  }
};

//GC customer
const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = InboundGrn();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
//API GET_BATCH_DETAILS_GETROW_001
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch?.ResultSet?.length > 0) {
      let GridID = vLandedCostDropdownSearch?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

const getQtyViewDetails = async (
  dispatch,
  setStockObj,
  xB_Srno,
  xB_Itmcd,
  xB_Qty,
  xB_Unit
) => {
  const { HeadObject } = InboundGrn();

  if (HeadObject.InboundType === "VENDOR_INV") {
    let PoQty = await GetPoQtyValidation(
      dispatch,
      xB_Srno,
      xB_Itmcd,
      xB_Qty,
      xB_Unit
    );
    if (PoQty?.length > 0) {
      setStockObj((obj) => ({
        BalanceQty: PoQty[0].BalanceQty,
        POQty: PoQty[0].POQty,
        GRNQty: PoQty[0].GRNQty,
      }));
    }
  } else if (HeadObject.InboundType === "TRANSFER_RETURN") {
    let tsrQty = await GetTsrQtyValidation(
      dispatch,
      xB_Srno,
      xB_Itmcd,
      xB_Qty,
      xB_Unit
    );
    if (tsrQty?.length > 0) {
      setStockObj((obj) => ({
        BalanceQty: tsrQty[0].BalanceQty,
        POQty: tsrQty[0].TransferQty,
        GRNQty: tsrQty[0].GRNQty,
      }));
    }
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setVirtualBin,
  setUnloading,
  setCurrency,
  setPalletType,
  setTeleUser=()=>{}
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await WMSInbound_grnAttributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setUnloading(iAttributes?.data?.ResultSet?.UnloadingBay);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setVirtualBin(iAttributes?.data?.ResultSet?.VirtualBin);
    setPalletType(iAttributes?.data?.ResultSet?.PalletType);
    setTeleUser(iAttributes?.data?.ResultSet?.TeleUser);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};

export const GetMSPUpdate = async (xVocTyp, xVocNo, setGridDataRows) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_VocTyp: xVocTyp,
    v_VocNo: xVocNo,
    v_TrnTyp: sTrnTyp,
    v_UserCd: vRdxUserInfoObj.UserID,
  };

  const iRespDetail = await WMSIInbound_WMINV03RSPMSPDetail_API(vObj);
  if (iRespDetail?.status === 200 && iRespDetail?.data?.ResultSet.length >0) {
    let vItemSearchArr = iRespDetail?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
      // MSPGPPerc: fCal_MSPGPPerc(obj.MSP, obj.CostPr),
      // TAXRSP: fCal_TAXRSP(obj.SellPr1, obj.TaxPerc),
      // GPPerc: fCal_GPPerc(obj.SellPr1, obj.CostPr),
    }));
    setGridDataRows(vItemSearchArr);

    return iRespDetail?.data?.ResultSet;
  } else {
    setGridDataRows([]);
    return [];
  }
};

export const fCal_MSPGPPerc = (xMSP, xCostPR) => {
  let MSPGPPerc =
    Number(xMSP) === 0
      ? 0
      : Number(
          (((Number(xMSP) - Number(xCostPR)) / Number(xMSP)) * 100).toFixed(2)
        );
  return MSPGPPerc;
};

export const fCal_TAXRSP = (xSellPr1, xTaxPer) => {
  let iTAXRSP = Number(xSellPr1) + (Number(xSellPr1) * Number(xTaxPer)) / 100;
  return iTAXRSP;
};

export const fCal_GPPerc = (xSellPr1, xCostPR) => {
  let iGPPerc =
    Number(xSellPr1) === 0
      ? 0
      : Number(
          (
            ((Number(xSellPr1) - Number(xCostPR)) / Number(xSellPr1)) *
            100
          ).toFixed(2)
        );
  return iGPPerc;
};
export const fCal_SellPr1 = (xTaxPerc, xTAXRSP) => {
  let SellPr1 =
    Number(xTaxPerc) + 100 === 0
      ? 0
      : (Number(xTAXRSP) * 100) / (Number(xTaxPerc) + 100);
  return SellPr1;
};


export const getRcvngPost = async (vObj) => {
  
  const iAttributes = await WMSInbound_validateReceivingPost_GETROW(vObj);
  if (iAttributes?.status === 200) {
    fAlertToast("SUCCESS","Receiving completed successfully.") 
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export {
  // rows,
  // columns,
  Get_GCSearchBtn,
  fRightClick,
  fLeftClick,
  getQtyViewDetails,
  sPaymode,
  sTax,
  sFrom,
  sFocFlagArr,
  TypeArr,
  fKeyInboundGrn,
  fKeyInboundGrnContent,
  // Api
  GetBuyer,
  GetSalesman,
  GetDefaultDrCrAccount,
  GetRefDocInbound,
  GetdRefNoV2,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetUnitRateArr,
  GetIncentiveGroup,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetTransTaxType,
  GrnRefNoValidation,
  GetItemAttributesPurchase,
  GetPoQtyValidation,
  GetTsrQtyValidation,
  GetSalesGroups,
  GetOtherSlabs,
  GetSupervisorSlabs,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fValidateItemsAttributes,
  fGetValidationDetailInfo,
  fSaveHead,
  fSaveDetail,
  fDisplay,

  //refdocmodal
  fRefDocRowClick,
  fCloseRefDocSearchModal,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head functions
  fDefaultPayload,
  fDiscFlagDependency,
  //Batch
  fValidationBatch_Client,
  GetSaveDetailBatch,
  GetDeleteDetailBatch,
  GetBatchDetail,

  //Approve
  GetValidateHead_Server,
  GetCheckPOCreditNoteAmount,
  GetValidateCostVariance,

  //src doc
  fReset_Linewise_Rebate,
  fBuyer_or_SalesMan,
  fBuyer_or_SalesMan_Arr,
  //GCLoadedCost
  Get_LoadedCost,
  Get_Loaded_Cost_WMINV03D_GetRow,
  GetDefcustomersetting,

  //GCCustomer
  Get_ToggleDropDown_Load,
};
